<nav class="navbar sticky-top navbar-dark ">
  <div class="col-12 text-center">
    <h1 class="navbar-brand mb-0 h1">Willand Garden Club</h1>
  </div>
  <div class="col-12 links nav navbar-nav">
    <div class="link-list col-lg-8 align-self-center ">
      <a class="nav-link" routerLink="">Home</a>
      <a class="nav-link" routerLink="/gallery">Gallery</a>
      <a class="nav-link" routerLink="/events">Events</a>
    </div>
  </div>
</nav>
